// import React, { useRef, useState, useEffect } from 'react';
// import './progress.css';

// const data = [10, 15, 20, 25, 30, 35];

// export default function Progress({ onChange  , value}) {
//   const [ptrPosition, setPtrPosition] = useState(0); // Initially set to 0
//   const [isMouseDown, setIsMouseDown] = useState(false);
//   const progressWrapperRef = useRef(null);

//   const steps = data.length;
//   const progressBarWidth = 334; // Total width of the progress bar
//   const incrementWidth = progressBarWidth / steps; // Width for each step

//   // Set initial value based on data
//   useEffect(() => {
//     if (data && data.length > 0) {
//       const initialValue = data[0]; // For example, starting at 10
//       const initialPosition = (value/ 35) * progressBarWidth;
//       onChange(value)
//       setPtrPosition(initialPosition); // Set initial pointer position
//     }
//   }, []);
//   useEffect(()=>{
//     console.log("progressWrapperRef" ,progressWrapperRef)
//   })

//   const handleClick = (e) => {
//     const rect = progressWrapperRef.current.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     updateProgress(x);
//   };

//   const handleMouseMove = (e) => {
//     if (!isMouseDown) return;
//     e.preventDefault();
//     const rect = progressWrapperRef.current.getBoundingClientRect();
//     const x = e.clientX - rect.left;
//     updateProgress(x);
//   };

//   const handleMouseDown = () => {
//     setIsMouseDown(true);
//   };

//   const handleMouseUp = () => {
//     setIsMouseDown(false);
//   };

//   const updateProgress = (x) => {
//     let finalPosition = Math.max(0, Math.min(x, progressBarWidth)); // Clamp x within 0 and the width of the progress bar
//     setPtrPosition(finalPosition);

//     let calculatedValue = Math.round((finalPosition / incrementWidth) * 5.8); // Calculate progress value
//     let finalValue = Math.min(calculatedValue, 35); // Clamp the value at the max (35)
//     onChange(finalValue);
//   };

//   return (
//     <div
//       className="progress-wrapper"
//       ref={progressWrapperRef}
//       onClick={handleClick}
//       onMouseMove={handleMouseMove}
//       onMouseDown={handleMouseDown}
//       onMouseUp={handleMouseUp}
//       onMouseLeave={() => setIsMouseDown(false)}
//     >
//       <div className="progress" style={{ width: `${ptrPosition}px` }}>
//         <div className="pointer" style={{ left: `${ptrPosition}px` }}>
//           <div className="toast"></div>
//         </div>
//       </div>
//     </div>
//   );
// }



import React, { useRef, useState, useEffect } from 'react';
import './progress.css';

const data = [10, 15, 20, 25, 30, 35]; // Defined steps (percentage values)

export default function Progress({ onChange, value }) {
  const [ptrPosition, setPtrPosition] = useState(0); // Initially set to 0
  const [isMouseDown, setIsMouseDown] = useState(false);
  const progressWrapperRef = useRef(null);

  const steps = data.length;
  const progressBarWidth = 334; // Total width of the progress bar
  const incrementWidth = progressBarWidth / steps; // Width for each step

  // Set initial value based on data
  useEffect(() => {
    if (data && data.length > 0) {
      // Set the initial value to 25% or the given value
      const initialValue = value || 25;
      const initialPosition = (initialValue / 35) * progressBarWidth;
      onChange(initialValue);
      setPtrPosition(initialPosition); // Set initial pointer position
    }
  }, [value]);

  const handleClick = (e) => {
    const rect = progressWrapperRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    updateProgress(x);
  };

  const handleMouseMove = (e) => {
    if (!isMouseDown) return;
    e.preventDefault();
    const rect = progressWrapperRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    updateProgress(x);
  };

  const handleMouseDown = () => {
    setIsMouseDown(true);
  };

  const handleMouseUp = () => {
    setIsMouseDown(false);
  };

  const updateProgress = (x) => {
    // Clamp the progress between 0 and progressBarWidth
    let finalPosition = Math.max(0, Math.min(x, progressBarWidth)); 

    // Make sure the value doesn't go below the minimum (10%)
    const minValuePosition = (10 / 35) * progressBarWidth;
    finalPosition = Math.max(finalPosition, minValuePosition); // Clamp to minimum value position

    setPtrPosition(finalPosition);

    // Calculate the value based on the position
    let calculatedValue = Math.round((finalPosition / progressBarWidth) * 35);
    let finalValue = Math.min(calculatedValue, 35); // Clamp the value at the max (35)
    onChange(finalValue);
  };

  return (
    <div
      className="progress-wrapper"
      ref={progressWrapperRef}
      onClick={handleClick}
      onMouseMove={handleMouseMove}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={() => setIsMouseDown(false)}
    >
      <div className="progress" style={{ width: `${ptrPosition}px` }}>
        <div className="pointer" style={{ left: `${ptrPosition}px` }}>
          <div className="toast"></div>
        </div>
      </div>
    </div>
  );
}
